import { DecorationSet } from '@atlaskit/editor-prosemirror/view';

export interface StartAction {
	type: 'START';
	data: {
		decorationSet: DecorationSet;
	};
}

export interface EndAction {
	type: 'END';
}

export interface InEditorStreamingPluginState {
	decorationSet: DecorationSet;
}

export function reducer(
	state: InEditorStreamingPluginState,
	action: StartAction | EndAction,
): InEditorStreamingPluginState {
	switch (action.type) {
		case 'START':
			return {
				...state,
				decorationSet: action.data.decorationSet,
			};
		case 'END':
			return {
				...state,
				decorationSet: DecorationSet.empty,
			};
		default:
			return state;
	}
}
